import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useScrollSpy } from "@/hooks/useScrollSpy";

const NAV_ITEMS = [
  { id: "hot", label: "实时热榜" },
  { id: "ranking", label: "榜单专区" },
  { id: "fans", label: "围观涨粉榜" },
  { id: "topics", label: "话题分类" },
  { id: "deepdive", label: "热门复盘" },
  { id: "faq", label: "常见问题" },
  { id: "about", label: "关于本站" },
];

const SECTION_IDS = NAV_ITEMS.map((item) => item.id);

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const activeId = useScrollSpy(SECTION_IDS);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0 group">
          <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center transition-transform group-hover:rotate-6">
            <i className="ri-fire-fill text-background-50 text-lg md:text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 whitespace-nowrap">
              瓜田热榜
            </span>
            <span className="hidden sm:block text-[10px] tracking-[0.18em] text-foreground-600 mt-1">
              全网吃瓜热榜聚合
            </span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`px-3 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
                activeId === item.id
                  ? "text-primary-400 bg-primary-500/10"
                  : "text-foreground-700 hover:text-foreground-950 hover:bg-background-200/60"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 shrink-0">
          <a
            href="#contact"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            <i className="ri-mail-send-line" />
            联系合作
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300/70 text-foreground-900 cursor-pointer hover:bg-background-200/60 transition-colors"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-100 border-t border-background-200/70 animate-fade-in">
          <nav className="px-4 md:px-8 py-4 flex flex-col gap-1" aria-label="移动端导航">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between px-3 py-3 rounded-md text-sm text-foreground-800 hover:bg-background-200/70 transition-colors cursor-pointer"
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-foreground-500" />
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setMenuOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-1.5 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-send-line" />
              联系合作
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}